// src/assets/data/cursos/cripto-blockchain/modulo-5.js
import banner from "../../../courses/module-2/img5.png";

const modulo5 = {
  courseId: "cripto-blockchain",
  id: "modulo-5",
  title: "🧩 MÓDULO 5: Seguridad en Web3 – Protege tus criptoactivos",
  estimatedDuration: "1 hora 30 minutos",
  format: "Lectura + actividad de verificación",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo del módulo",
      content: [
        "Entender cómo funcionan las wallets, qué es una seed phrase y cómo evitar los principales riesgos en el ecosistema cripto.",
      ],
    },
    {
      id: "wallet",
      navLabel: "¿Qué es una wallet?",
      title: "🔐 ¿Qué es una wallet?",
      content: [
        {
          type: "paragraph",
          text: "Una wallet (billetera digital) es una herramienta que te permite guardar, enviar y recibir criptomonedas.",
        },

        {
          type: "paragraph",
          text: "Tipos de wallets:",
        },
        {
          type: "table",
          headers: ["Tipo", "Descripción", "Ejemplo"],
          rows: [
            [
              "Custodial",
              "Un tercero (como una empresa) guarda tus claves por ti. Tú accedes con usuario y contraseña.",
              "Binance, Bitso, etc..",
            ],
            [
              "Non-custodial",
              "Solo tú tienes control total. Nadie más puede acceder a tus fondos si pierdes tu clave.",
              "MetaMask, Trust Wallet, Vesseo, etc..",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "⚠️ Importante: Si pierdes el acceso a una non-custodial wallet y no tienes respaldo, nadie podrá ayudarte a recuperar tus fondos.",
        },
      ],
    },
    {
      id: "banco-vs-wallet",
      navLabel: "Wallet vs Banco",
      title: "🏦 Wallet vs Banco: ¿Cuál es la diferencia?",
      content: [
        {
          type: "paragraph",
          text: "Aunque ambos permiten guardar y mover dinero, una wallet cripto y un banco tradicional funcionan de formas muy distintas:",
        },
        {
          type: "table",
          headers: ["Aspecto", "Banco tradicional", "Wallet cripto"],
          rows: [
            [
              "Control del dinero",
              "El banco tiene custodia. Puede congelar o bloquear tu cuenta.",
              "Tú tienes el 100% del control. Nadie puede mover tu dinero sin tu autorización.",
            ],
            [
              "Requisitos para abrir cuenta",
              "Documentación, verificación, historial crediticio.",
              "Cualquiera puede crear una wallet. No se necesita identificación.",
            ],
            [
              "Horario de funcionamiento",
              "Lunes a viernes, horarios limitados.",
              "24/7, sin interrupciones.",
            ],
            [
              "Comisiones",
              "Comisiones por mantenimiento, transferencias, cajeros.",
              "Depende de la red. A veces muy bajas, pero no hay cargos ocultos.",
            ],
            [
              "Privacidad",
              "Tus datos están registrados por el banco y pueden compartirse con gobiernos o empresas.",
              "No necesitas compartir tus datos personales para usar una wallet.",
            ],
            [
              "Soporte técnico",
              "Puedes llamar o ir a una sucursal si tienes un problema.",
              "En wallets non-custodial, tú eres tu propio banco. Si pierdes tus claves, nadie puede ayudarte.",
            ],
          ],
        },

        {
          type: "paragraph",
          text: "🎯 Conclusión",
        },
        {
          type: "list",
          items: [
            "Un banco te ofrece comodidad y protección, pero también controla tu dinero.",
            "Una wallet cripto te da libertad, pero requiere responsabilidad total.",
          ],
        },
      ],
    },
    {
      id: "seed-phrase",
      navLabel: "Seed phrase",
      title: "🧠 Seed phrase: tu llave maestra",
      content: [
        {
          type: "paragraph",
          text: "Una seed phrase es una serie de 12 o 24 palabras que representan tu wallet. Es lo más valioso en Web3.",
        },
        {
          type: "paragraph",
          text: "Reglas de oro:",
        },
        {
          type: "list",
          items: [
            "Escríbela en papel, no en el celular ni en capturas de pantalla.",
            "Guárdala en un lugar seguro, sin acceso digital.",
            "No la compartas con nadie, nunca.",
          ],
        },
      ],
    },
    {
      id: "custodial-vs-non-custodial",
      navLabel: "Custodial vs Non-Custodial",
      title: "🛡 Custodial vs Non-Custodial",
      content: [
        {
          type: "table",
          headers: ["Característica", "Custodial", "Non-Custodial"],
          rows: [
            ["Control de fondos", "Empresa", "Usuario"],
            [
              "Recuperación si olvidas acceso",
              "Posible",
              "Solo con seed phrase",
            ],
            [
              "Seguridad",
              "Alta si confías en la empresa",
              "Alta con buenas precauciones",
            ],
          ],
        },
      ],
    },
    {
      id: "riesgos",
      navLabel: "Riesgos comunes",
      title: "⚠️ Riesgos comunes en Web3 (¡y cómo evitarlos!)",
      content: [
        {
          type: "paragraph",
          text: "🧪 1. Phishing – Engaños para robar tus claves",
        },
        {
          type: "list",
          items: [
            "Imitan sitios reales (como MetaMask) para que ingreses tu seed phrase.",
            "Ejemplo real: Usuarios que cayeron en páginas falsas perdieron todos sus fondos.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Evita: nunca ingreses tu seed phrase en ningún sitio web. Solo en tu app oficial.",
        },
        {
          type: "paragraph",
          text: "🕷️ 2. Malware – Programas que roban tu información",
        },
        {
          type: "paragraph",
          text: "Tipos más comunes:",
        },
        {
          type: "list",
          items: [
            "Clipper malware: cambia la dirección copiada por la del estafador.",
            "Keylogger: graba todo lo que escribes, incluyendo contraseñas.",
            "Extensiones falsas: se disfrazan de herramientas útiles (como traductores), pero espían tu actividad.",
          ],
        },
        {
          type: "paragraph",
          text: "Ejemplo real: Una app falsa en Android alteraba direcciones de wallet copiadas. Los usuarios no notaban hasta que era tarde.",
        },
        {
          type: "paragraph",
          text: "✅ Evita: no descargues apps ni extensiones desconocidas. Usa antivirus.",
        },
        {
          type: "paragraph",
          text: "💨 3. Rugpulls – Proyectos falsos que desaparecen con tu dinero",
        },
        {
          type: "list",
          items: [
            "Caso famoso: El token SQUID (inspirado en 'El juego del calamar') subió a $2.800 y luego colapsó. Los creadores desaparecieron con el dinero.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Evita: investiga antes de invertir. Si suena demasiado bueno para ser verdad, probablemente lo sea.",
        },
        {
          type: "paragraph",
          text: "🧪 4. Links falsos en redes sociales",
        },
        {
          type: "list",
          items: [
            "Aparecen en comentarios de Instagram, Telegram, Discord, etc.",
            "Se hacen pasar por “soporte técnico”.",
          ],
        },
        {
          type: "paragraph",
          text: "✅ Evita: nunca ingreses tus datos en links recibidos por mensajes directos. Solo contacta soporte oficial.",
        },
      ],
    },
    {
      id: "practicas",
      navLabel: "Buenas prácticas",
      title: "🔒 Buenas prácticas de seguridad",
      content: [
        {
          type: "orderedList",
          items: [
            "Activa la verificación en dos pasos (2FA) siempre que sea posible.",
            "Nunca compartas tu seed phrase.",
            "Usa wallets oficiales y descárgalas desde tiendas verificadas.",
            "No guardes claves en correo o nube.",
            "Revisa dos veces antes de confirmar transacciones.",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad",
      title: "📝 Actividad del módulo",
      content: [
        {
          type: "paragraph",
          text: "Parte 1: Lista de buenas prácticas",
        },
        {
          type: "list",
          items: [
            "Abre un nuevo documento en Google Docs.",
            "Escribe una lista de tus 5 reglas personales de seguridad para el mundo cripto.",
            "Ejemplo de título: “Mi Manual de Supervivencia Web3”",
          ],
        },
        {
          type: "paragraph",
          text: "Parte 2: Simulación",
        },
        {
          type: "paragraph",
          text: "Responde brevemente en el mismo documento:",
        },
        {
          type: "list",
          items: [
            "¿Qué harías si perdieras tu teléfono con tu wallet non-custodial instalada (como Vesseo o Trust Wallet)?",
            "¿Qué pasos seguirías para proteger tus fondos o intentar recuperarlos?",
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recursos recomendados",
      title: "📌 Recursos recomendados",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/how-to-secure-your-cryptocurrency",
          text: "Binance Academy – Seguridad Cripto",
        },
        {
          type: "link",
          href: "https://www.bitpanda.com/academy/es/lecciones/como-puedo-mantener-mis-criptomonedas-seguras/",
          text: "Bitpanda – Mantén tus criptos seguras",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: [
        "“En Web3, no hay bancos. No hay jefes. Solo tú. Y eso significa libertad… pero también responsabilidad.”",
      ],
    },
  ],
};

export default modulo5;
